﻿/**
 * This value is replaced by the environment variable
 * `ENV` during the build process.
 */
export var ENV = process.env.ENV;

/**
 * True if the environment is run locally on
 * the developers machine using `npm run start`.
 * 
 * When a build is done and those files are served locally
 * this won't be true.
 * Note: isDevelopment will also be true
 */
export var isLocal = ENV == 'local'

export var isDevelopment = ENV == 'dev' || ENV == 'development';
export var isUAT = ENV == 'uat' || ENV == 'test';
export var isTraining = ENV == 'trn' || ENV == 'training' || ENV == 'train';
export var isProduction = ENV == 'prd' || ENV == 'production' || ENV == 'prod';

// Development URLs are default
export var APP_BASE_URL = 'https://fireweather.aig.dev.apps.rfs.nsw.gov.au';
export var BOM_BASE_URL = 'https://spatial.bom.gov.au';
export var FIREWEATHER_API_URL = 'https://shared-fireweather.dev.apps.rfs.nsw.gov.au/api';
export var GEOSERVER_URL = "https://fireweather.aig.dev.apps.rfs.nsw.gov.au/geoserver/fireweather/wms";
export var GEOSERVER_URL_BOM = "https://fireweather.aig.dev.apps.rfs.nsw.gov.au/bom";

// export var FIREWEATHER_API_URL = 'https://shared-fireweather.dev.apps.rfs.nsw.gov.au/api';
// export var GEOSERVER_URL = "https://941107302203-fireweather-geoserver.aig.dev.apps.rfs.nsw.gov.au/geoserver/fireweather/wms"
export var INCORRECT_GEOSERVER_URL = "http://941107302203-fireweather-geoserver.aig.dev.apps.rfs.nsw.gov.au/geoserver/fireweather/ows"
export var INCORRECT_GEOSERVER_SUBDOMAIN = "941107302203-fireweather-geoserver.aig"

// OKAT Configuration
export var OKTA_CONFIG = {
    issuer: '',
    clientId: '',
    scopes: ['openid','email'],
    storage: 'sessionStorage',
    useInteractionCodeFlow: true,
    requireUserSession: 'true',
    authMethod: 'form',
    startService: false,
    useDynamicForm: false,
    uniq: Date.now() + Math.round(Math.random() * 1000), // to guarantee a unique state
    idps: '',
    redirectUri:window.location.origin + '/login/callback.html', // Should also be set in Okta Admin UI
    getTokens: true,
    appUri:window.location.origin + '/index.html',
    state: {
        appUri: null
    }
}

if (isLocal) {
    // Special case; If a local build, services won't exist
    // production services are used for now as no other service
    // is easily accessible. Once environments are setup, these 
    // urls can change
    // FIREWEATHER_API_URL = 'fireweather.rfs.nsw.gov.au/api';
    // GEOSERVER_URL = "fireweather.rfs.nsw.gov.au/geoserver/fireweather/wms"
    
    Object.assign(OKTA_CONFIG, {
        baseUrl: 'https://identity.dev.rfs.nsw.gov.au', 
        issuer:'https://identity.dev.rfs.nsw.gov.au/oauth2/aus61r9dx7pehrNvQ1d7', 
        clientId:'FireWeatherWebsiteDEV',
    });       
    // Object.assign(OKTA_CONFIG, {
    //     baseUrl: 'https://rfsdev.oktapreview.com', 
    //     issuer:'https://rfsdev.oktapreview.com/oauth2/default',  
    //     clientId:'FireWeatherWebsiteDEV',
    // });       
}
else if (isDevelopment) {
    // UAT URLs
    APP_BASE_URL = 'https://fireweather.aig.dev.apps.rfs.nsw.gov.au';
    FIREWEATHER_API_URL = 'https://shared-fireweather.dev.apps.rfs.nsw.gov.au/api';
    GEOSERVER_URL = "https://fireweather.aig.dev.apps.rfs.nsw.gov.au/geoserver/fireweather/wms";
    INCORRECT_GEOSERVER_URL = "https://941107302203-fireweather-geoserver.aig.dev.apps.rfs.nsw.gov.au/geoserver/fireweather/ows";
    INCORRECT_GEOSERVER_SUBDOMAIN = "941107302203-fireweather-geoserver.aig";

    // OKTA Configuration
    Object.assign(OKTA_CONFIG, {
        baseUrl: 'https://identity.dev.rfs.nsw.gov.au', 
        issuer:'https://identity.dev.rfs.nsw.gov.au/oauth2/aus61r9dx7pehrNvQ1d7',  
        //issuer:'https://identity.dev.rfs.nsw.gov.au/oauth2/aus61r9dx7pehrNvQ1d7',  
        clientId:'FireWeatherWebsiteDEV',
    });    
}
else if (isUAT) {
    // UAT URLs
    APP_BASE_URL = 'https://fireweather.aig.uat.apps.rfs.nsw.gov.au';
    FIREWEATHER_API_URL = 'https://shared-fireweather.uat.apps.rfs.nsw.gov.au/api';
    GEOSERVER_URL = "https://fireweather.aig.uat.apps.rfs.nsw.gov.au/geoserver/fireweather/wms";
    INCORRECT_GEOSERVER_URL = "https://577285248931-fireweather-geoserver.aig.uat.apps.rfs.nsw.gov.au/geoserver/fireweather/ows";
    INCORRECT_GEOSERVER_SUBDOMAIN = "577285248931-fireweather-geoserver.aig";

    // OKTA Configuration
    Object.assign(OKTA_CONFIG, {
        baseUrl: 'https://identity.dev.rfs.nsw.gov.au', 
        issuer:'https://identity.dev.rfs.nsw.gov.au/oauth2/aus65dw7d3sYdIAf61d7',  
        //issuer: 'https://identity.dev.rfs.nsw.gov.au/oauth2/aus65dw7d3sYdIAf61d7',
        clientId:'FireWeatherWebsiteUAT',
    });    
} else if (isTraining) {
    // Training URLs
    APP_BASE_URL = 'https://fireweather.aig.trn.apps.rfs.nsw.gov.au';
    FIREWEATHER_API_URL = 'https://shared-fireweather.trn.apps.rfs.nsw.gov.au/api';
    GEOSERVER_URL = "https://fireweather.aig.trn.apps.rfs.nsw.gov.au/geoserver/fireweather/wms";
    INCORRECT_GEOSERVER_URL = "https://345503952331-fireweather-geoserver.aig.trn.apps.rfs.nsw.gov.au/geoserver/fireweather/ows";
    INCORRECT_GEOSERVER_SUBDOMAIN = "345503952331-fireweather-geoserver.aig";
    // OKTA Configuration
    Object.assign(OKTA_CONFIG, {
        baseUrl: 'https://identity.rfs.nsw.gov.au', 
        issuer:'https://identity.rfs.nsw.gov.au/oauth2/aus25rpdahNJaqfwN3l7',  
        //issuer: 'https://identity.rfs.nsw.gov.au/oauth2/aus25rpdahNJaqfwN3l7',
        clientId:'FireWeatherWebsiteTRN',
    });   
} else if (isProduction) {
    // Production URLs
    APP_BASE_URL = 'https://fireweather.aig.apps.rfs.nsw.gov.au';    
    FIREWEATHER_API_URL = 'https://shared-fireweather.apps.rfs.nsw.gov.au/api';
    GEOSERVER_URL = "https://fireweather.aig.apps.rfs.nsw.gov.au/geoserver/fireweather/wms";
    INCORRECT_GEOSERVER_URL = "https://974345572517-fireweather-geoserver.aig.apps.rfs.nsw.gov.au/geoserver/fireweather/ows";
    INCORRECT_GEOSERVER_SUBDOMAIN = "974345572517-fireweather-geoserver.aig";
    // OKTA Configuration
    Object.assign(OKTA_CONFIG, {
        baseUrl: 'https://identity.rfs.nsw.gov.au', 
        issuer:'https://identity.rfs.nsw.gov.au/oauth2/aus25rq992jHGgeAc3l7', 
        //issuer:'https://identity.rfs.nsw.gov.au/oauth2/aus25rq992jHGgeAc3l7', 
        clientId:'FireWeatherWebsitePROD',
    });    
}